import React from 'react';

const Checkbox = ({ value, changeValue, title, name, asterix, errorMessage }) => (
  <div className="checkbox">
    <label>
      <input type="checkbox" checked={value} onChange={changeValue} name={name}/>
      <span className="checkbox-label">{title}<span className="white">{asterix}</span></span>
    </label>
    { errorMessage && <div className="validation-error red">{errorMessage}</div>}
  </div>
);

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.js